const comments = [
  {
    name: '资深影迷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20person%20in%20warm%20lighting%2C%20simple%20neutral%20background%2C%20friendly%20expression%2C%20clean%20professional%20look&width=80&height=80&seq=avatar-01-user&orientation=squarish',
    text: '资源真的很全，想看的电影基本都能找到，而且更新速度很快。天美麻花星空影视的内容也同步得特别及时，追剧太方便了！',
    date: '2天前',
  },
  {
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20young%20Asian%20person%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20neutral%20background%2C%20casual%20professional%20headshot&width=80&height=80&seq=avatar-02-user&orientation=squarish',
    text: '高清不缓冲这点是真的好，晚上高峰期看剧也很流畅，比很多平台都强。现在每天都会来91影视看片下载看看有没有新剧更新。',
    date: '5天前',
  },
  {
    name: '忠实用户',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Asian%20adult%20with%20gentle%20expression%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20natural%20professional%20headshot&width=80&height=80&seq=avatar-03-user&orientation=squarish',
    text: '麻花星空影视免费观看的内容也都在这里能找到，一站式追剧再也不用到处找了。而且免费影视大全资源多，从国产剧到韩剧美剧都有覆盖。',
    date: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            用户好评
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            真实用户观影反馈
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            来看看资深影迷们对91影视看片下载的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-5">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div>
                  <div className="text-foreground-900 text-sm font-semibold">{comment.name}</div>
                  <div className="text-foreground-500 text-xs">{comment.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}